export const enum FeatureToggleName {
  CERTIFICATES_ENABLED = 'CERTIFICATES_ENABLED',
  CONTACT_OPTIONS_ENABLED = 'CONTACT_OPTIONS_ENABLED',
  IPDC_PRODUCTS_ENABLED = 'IPDC_PRODUCTS_ENABLED',
  IPDC_THEMES_ENABLED = 'IPDC_THEMES_ENABLED',
}
